export {Registry} from "@tsed/core";
export * from "@tsed/di";
export * from "./config";
export * from "./jsonschema";
export * from "./mvc";
export * from "./platform";
export * from "./platform-builder";
export * from "./platform-exceptions";
export * from "./platform-test";
export * from "./platform-response-filter";

export {$log, Logger} from "@tsed/logger";
